'use client';
import Button from '@/components/Button';
import Field from '@/components/Field';
import FormError from '@/components/FormError';
import { fullPageLoadingIndicator } from '@/components/LoadingIndicator';
import TextInput from '@/components/TextInput';
import Upload from '@/components/Upload';
import useMedicalProfessionalDiscounts from '@/hooks/MedicalProfessionalDiscounts/useMedicalProfessionalDiscounts';
import { useIsMobile } from '@/hooks/use-is-mobile';
import combine from '@/util/combineValidators';
import { isRequired, validateEmail } from '@/util/formValidators';
import { Form } from 'informed';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Banner } from './banner';
import classes from './medicalProfessionalDiscounts.module.css';
import { SuccessDialog } from './successDialog';
const MedicalProfessionalDiscounts = props => {
  const uploadRef = useRef(null);
  const talonProps = useMedicalProfessionalDiscounts({
    uploadRef,
  });
  const { formatMessage } = useIntl();
  const isMobile = useIsMobile();
  const [showModal, setShowModal] = useState(false);
  const removeIcon = (
    <Image
      className='removeIcon h-[13px] w-[13px] lg_h-[20px] lg_w-[20px]'
      src='upload-remove.svg'
      alt='remove icon'
      width={20}
      height={20}
    />
  );

  const { isLoading, errors, handleSubmit, response, formApiRef } = talonProps;

  const maybeLoadingIndicator = isLoading ? fullPageLoadingIndicator : null;
  useEffect(() => {
    if (response && response.code === '200') {
      setShowModal(true);
    }
  }, [response]);

  return (
    <div className='pb-[40px] lg_pb-[80px]'>
      <Banner
        url={'/discount/medical-banner'}
        title='15% OFF Medical Worker Discount'
        text='Thank you for your dedication and service.<br/> We’re proud to support you!'
        classes={{
          titlePc: 'text-black ![text-shadow:none]',
          titleMobile: 'text-black ',
          textPc: 'text-black ![text-shadow:none]',
          textMobile: 'text-black',
        }}
      />
      {/* {maybeLoadingIndicator} */}
      <article className='personalContent mx-auto'>
        <div className='mb-[40px] px-[12px] lg_mb-[60px] lg_px-0'>
          <div className=''>
            <FormError
              allowErrorMessages
              errors={Array.from(errors.values())}
            />
            <Form
              className='grid'
              onSubmit={handleSubmit}
              formApiRef={formApiRef}
            >
              <div className=' flex flex-col justify-between lg_flex-row'>
                <Field
                  id='first-name'
                  classes={{
                    root: classes.nameField,
                    requiredLabel: classes.requiredLabel,
                    labelText: classes.labelText,
                  }}
                  label='First Name'
                  required
                >
                  <TextInput
                    autoComplete='firstName'
                    field='firstname'
                    id='firstname'
                    validate={isRequired}
                    // placeholder={formatMessage({
                    //   id: 'militaryDiscountsPage.firstNamePlaceholder',
                    //   defaultMessage: `First Name*`,
                    // })}
                  />
                </Field>
                <Field
                  id='last-name'
                  classes={{
                    root: classes.nameField,
                    requiredLabel: classes.requiredLabel,
                    labelText: classes.labelText,
                  }}
                  label='Last Name'
                  required
                >
                  <TextInput
                    autoComplete='lastName'
                    field='lastname'
                    id='lastname'
                    validate={isRequired}
                    // placeholder={formatMessage({
                    //   id: 'militaryDiscountsPage.lastNamePlaceholder',
                    //   defaultMessage: `Last Name*`,
                    // })}
                  />
                </Field>
              </div>
              <div className='mb-[20px]'>
                <Field
                  id='contact-email'
                  classes={{
                    root: classes.emailField,
                    requiredLabel: classes.requiredLabel,
                    labelText: classes.labelText,
                  }}
                  label='Email'
                  required
                >
                  <TextInput
                    autoComplete='email'
                    field='email'
                    id='contact-email'
                    validate={combine([isRequired, validateEmail])}
                    // placeholder={formatMessage({
                    //   id: 'militaryDiscountsPage.emailPlaceholder',
                    //   defaultMessage: 'Email*',
                    // })}
                  />
                </Field>
              </div>

              <div className='mb-[10px]'>
                {/* <p className={classes.uploadTip}>
                    <span className={classes.uploadTipBold}>
                      <span className={classes.required}>*</span>
                      Photo of your Medical ID document:
                    </span>
                    (1 image, JPG/PNG only)
                  </p> */}
                <Upload
                  ref={uploadRef}
                  showUploadList={{
                    showDownloadIcon: false,
                    showPreviewIcon: false,
                    showRemoveIcon: true,
                    removeIcon: removeIcon,
                  }}
                />
              </div>
              <p className='mb-[5px] flex items-center justify-start gap-[10px] lg_mb-[10px]'>
                <Image
                  src={`/discount/pic-icon.svg`}
                  alt='Upload Icon'
                  width={22}
                  height={20}
                  className='h-[20px] w-[22px]'
                />
                <span className='font-roboto-medium text-[16px] font-medium leading-[24px]'>
                  Photo of Your Medical Worker ID
                </span>
              </p>
              <p className='mb-[10px] font-roboto-light text-[12px] leading-[20px]'>(1 image, JPG/PNG only)</p>
              <p className='mb-[20px] font-roboto-regular text-[16px] font-normal leading-[24px]'>
                Note: Only your name is required. You may obscure any other sensitive information.
              </p>
              <div className=''>
                <Button
                  priority='high'
                  type='submit'
                  disabled={isLoading}
                  loading={isLoading}
                  className='duration-300 h-[40px] w-full rounded-full bg-black font-roboto-medium text-[16px] leading-[40px] text-white transition-colors hover_bg-[#4C4C4C] lg_h-[50px] lg_w-[140px] lg_text-[18px] lg_leading-[50px]'
                >
                  <FormattedMessage
                    id={'militaryDiscountsPage.submit'}
                    defaultMessage={'Submit'}
                  />
                </Button>
              </div>
            </Form>
          </div>
        </div>
        <div className='lg-px-0 bg-[#F9F9F9] px-[12px] pb-[30px] pt-[40px] lg_bg-white  lg_pt-0 lg_pt-0'>
          <h2 className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[30px] lg_mb-[10px] lg_text-[40px] lg_leading-[40px]'>
            Frequently Asked Questions
          </h2>
          <p className='mb-[10px] font-roboto-medium text-[16px] font-medium leading-[19px] lg_text-[18px] lg_leading-[21px]'>
            1. Who is eligible for the Medical Worker Discount?
          </p>
          <ul className='mb-[20px]'>
            {[
              'Emergency Medical Technicians (EMTs)',
              'Paramedics',
              'Registered Nurses (RNs)',
              'Trauma Nurses',
              'Nurse Practitioners',
              'Hospital Physicians, Physician Assistants (PAs), Technicians, and other hospital staff',
            ].map((item, index) => (
              <li
                key={index}
                className='mb-[10px] flex items-baseline gap-[10px]'
              >
                <i className='relative top-[-2px] inline-block !h-[6px] min-h-[6px] !w-[6px] min-w-[6px] rounded-[3px] bg-black'></i>
                <span
                  className='font-roboto-light text-[14px] font-light leading-[20px] lg_text-[16px] lg_leading-[26px]'
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </ul>
          <p className='mb-[10px] font-roboto-medium text-[16px] font-medium leading-[19px] lg_text-[18px] lg_leading-[21px]'>
            2. How do I verify my eligibility?
          </p>
          <p className='mb-[20px] font-roboto-light text-[14px] font-light leading-[20px] lg_text-[16px] lg_leading-[26px]'>
            Verification is quick and simple! Just fill out the form above and upload a photo of your Medical Worker ID
            so we can confirm your eligibility for the Medical Worker Discount. <br />
            <br />
            We’ll verify your information within 48 hours and send your discount code via email. Please make sure to
            enter your first and last name exactly as they appear on your Medical Worker ID.
          </p>
          <p className='mb-[10px] font-roboto-medium text-[16px] font-medium leading-[19px] lg_text-[18px] lg_leading-[21px]'>
            3. Can I use the Medical Worker Discount for past orders?
          </p>
          <p className='mb-[40px] font-roboto-light text-[14px] font-light leading-[20px] lg_mb-[60px] lg_text-[16px] lg_leading-[26px]'>
            Unfortunately, the discount cannot be applied to previous orders placed on hisea.com or through other sales
            channels, such as Amazon, eBay, or Walmart. It can only be used for current and future orders.
          </p>
          <h2 className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[30px] lg_mb-[10px] lg_text-[40px] lg_leading-[40px]'>
            Terms & Conditions
          </h2>
          <ul className=''>
            {[
              'The discount takes 15% off your order, excluding shipping fees.',
              "Only one discount code can be used per order, and it's valid on full-price items only.",
              'The coupon code must be used on an order placed under your name and email address. Orders placed under a different name may be canceled without notice.',
              'Orders placed before receiving your discount code are not eligible for reimbursement.',
              'By submitting this form, you confirm that you have read and agree to these terms and conditions.',
              'Your information will not be collected or stored by HISEA. It will only be used for verification purposes.',
              'If you have trouble receiving your discount code or have any questions, please feel free to contact us at <a href="mailto:cs@hisea.com" style="text-decoration: underline; font-weight: 600;">cs@hisea.com</a>.',
            ].map((item, index) => (
              <li
                key={index}
                className='mb-[10px] flex items-baseline gap-[10px]'
              >
                <i className='relative top-[-2px] inline-block !h-[6px] min-h-[6px] !w-[6px] min-w-[6px] rounded-[3px] bg-black'></i>
                <span
                  className='font-roboto-light text-[14px] font-light leading-[20px] lg_text-[16px] lg_leading-[26px]'
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </ul>
        </div>
      </article>
      {showModal && (
        <SuccessDialog
          titlePc='Application Received-Thank You for Your Service!'
          titleMobile='Application Received<br/>Thank You for Your Service!'
          textPc={[
            'We appreciate your application for our medical worker discount. ',
            'Our team is verifying information, which typically takes 1-2 business days.',
            "Once approved, you'll receive an email with your unique discount code.",
          ]}
          textMobile={[
            'We appreciate your application for our medical worker discount. ',
            'Our team is verifying information, which typically takes 1-2 business days.',
            "Once approved, you'll receive an email with your unique discount code.",
          ]}
          handleClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default MedicalProfessionalDiscounts;
